import React from "react";
import styled from 'styled-components'
import Text from "../../../../../_components/Text"

const Card = styled.div`
-webkit-box-shadow: 1px 7px 18px -6px rgba(0,0,0,0.75);
-moz-box-shadow: 1px 7px 18px -6px rgba(0,0,0,0.75);
box-shadow: 1px 7px 18px -6px rgba(0,0,0,0.75);
border-radius: 30px;
padding: 20px;
margin-bottom: 30px;
`

const CardHeader = styled.div`
display: flex;
flex-direcion: row;
justify-content: space-between;
`
const CardFooter = styled.div`
  text-alig: center;
  min-height: 50px;
`

export default props => <Card>
    <CardHeader loading={props.loading}>
        <h3 className="text-capitalize">
            {
                props.loading
                    ? <i className="fas fa-spinner fa-pulse"></i>
                    : <Text fontSize=".9em">{props.title}</Text>
            }
        </h3>
        <h3 className="text-capitalize">
            {
                props.loading
                    ? <i className="fas fa-spinner fa-pulse"></i>
                    : <Text fontSize=".9em">{props.amountValue}</Text>
            }
        </h3>
    </CardHeader>
    <CardFooter>
        {
            props.footerElement
        }
    </CardFooter>
    {props.selectComponent? 
    <div>

        {props.selectComponent} 
    </div>
    
    : 
    <React.Fragment/> 
    }
</Card>


// WEBPACK FOOTER //
// ./src/views/AppViews/Dashboard/components/LoadingCard/index.jsx